import { BreakUiCoursesComponent } from './features/courses/components/break-ui-courses/break-ui-courses.component';
// import { environment } from '../environments/environment';
import { BreakUiHomepageComponent } from './features/homepage/components/break-ui-homepage/break-ui-homepage.component';
import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, Route } from '@angular/router';
import { actionRegList, DwAuthGuardService, DwLoginComponent, DwRouteGuardUtil, DwSsoLoginComponent, UserProfileComponent, DwUserRegistrationComponent, DevwareGetStartedComponent, DwGridQuickSearchActionComponent, DwGridCancelInlineEditsActionService, DwActionFunc, DwActionType, DwDecoratorType, DwGridActionConfig, DwGridActionKeys, DwGridQuickSearchConfigComponent, _dwActionGridQuickSearch, DwGridColumnActionButtonsComponent, DwPage404Component, DwCanDeactivateGuard, DevwareAdminModule, DwDefaultFormPage } from '@devwareapps/devware-cap';
import { AviatorOnlineHomePageComponent } from './features/homepage/components/aviator-online-home-page/aviator-online-home-page.component';
import { CourseCardComponent } from './features/courses/components/cards/course-card/course-card.component';
import { CoursePageComponent } from './features/courses/components/course-page/course-page.component';
import { CourseStudentProgressCardComponent } from './features/courses/components/cards/course-student-progress-card/course-student-progress-card.component';
import { ManagerUserUtilComponent } from './features/schools/components/manager-user-util/manager-user-util.component';
import { DwComponentList } from './app-routing-tree-shaking';
import { AviatorRouteGuardService } from './features/shared/route-guards/aviator-route-guard.service';
import { AviatorLoginPageComponent } from './features/homepage/components/aviator-login-page/aviator-login-page.component';
import { AviatorRegistrationPageComponent } from './features/homepage/components/aviator-registration-page/aviator-registration-page.component';
import { AviatorNotFoundComponent } from './features/homepage/components/aviator-not-found/aviator-not-found.component';
import { DocumentsPageComponent } from './features/documents/components/documents-page/documents-page.component';
import { AppMetaData, AppMetaDataItemNames } from './meta-data/app-meta-data.service';
import { DocumentsRoutingUtilsService } from './features/documents/services/documents-routing-utils.service';
import { ScenarioBuilderPageComponent } from './features/scenarios/components/scenario-builder-page/scenario-builder-page.component';
import { QuizBuilderProPageComponent } from './features/quizzes/components/quiz-builder-pro-page/quiz-builder-pro-page.component';
import { G1000PrototypePageComponent } from './features/shared/components/g1000-prototype-page/g1000-prototype-page.component';
import { environment } from '../environments/environment';



@Component({
    selector: 'sevice-dependencies',
    template: `Service Dependencies`,
})
export class ServiceDependenciesComponent {
    constructor(private dwGridCancelInlineEditsActionService: DwGridCancelInlineEditsActionService) { }
}

const routes = [
    // Explicit names also prevent collisions with older CAP versions that match blank menu displays.
    ...(!environment.production && ['localhost', '127.0.0.1'].includes(location.hostname) ? [{ path: 'break-ui-courses', component: BreakUiCoursesComponent, data: {routeId: 'break-ui-courses', display: 'Break UI Courses', showInMenu: false} }] : []),
    ...(!environment.production && ['localhost', '127.0.0.1'].includes(location.hostname) ? [{ path: 'break-ui-homepage', component: BreakUiHomepageComponent, data: {routeId: 'break-ui-homepage', display: 'Break UI Homepage', showInMenu: false} }] : []),
    {
        path: '',
        component: AviatorOnlineHomePageComponent,
        data: {
            display: 'Dashboard',
            iconCssClass: 'fa fa-menu-icon fa-home',
            routeOrder: 5,
            hideBreadcrumbParent: true,
            excludeFromMainMenu: false,
            showInMenu: true,
            highlightOnExactMatch: true,
            referenceKey: 'home',
        }
    },
    {
        path: 'login',
        component: AviatorLoginPageComponent,
        canActivate: [AviatorRouteGuardService],
        data: {
            routeId: 'login',
            display: 'Login',
            iconCssClass: 'fa fa-menu-icon fa-power-off',
            showInMenu: false,
            referenceKey: 'login'
        }
    },
    {
        path: 'register/verification',
        component: AviatorRegistrationPageComponent,
        canActivate: [AviatorRouteGuardService],
        data: {
            routeId: 'register-verification',
            display: 'Verify Email',
            showInMenu: false,
            routeOrder: 16,
            referenceKey: 'register-verification',
        }
    },
    {
        path: 'register/profile',
        component: AviatorRegistrationPageComponent,
        canActivate: [AviatorRouteGuardService],
        data: {
            routeId: 'register-profile',
            display: 'Profile',
            showInMenu: false,
            routeOrder: 16,
            referenceKey: 'register-profile',
        }
    },
    {
        path: 'register',
        component: AviatorRegistrationPageComponent,
        canActivate: [AviatorRouteGuardService],
        //canActivate: [DwAuthGuardService],
        data: {
            routeId: 'register',
            display: 'Register',
            showInMenu: false,
            routeOrder: 16,
            referenceKey: 'register',
        }
    },
    {
        path: 'resources',
        data: {
            display: 'Resources'
        },
        children: [
            { 
                path: 'documents',
                component: DocumentsPageComponent,
                canActivate: [AviatorRouteGuardService],
                data: {
                    routeId: 'documents-new',
                    display: 'Documents',
                    showInMenu: false,
                    excludeFromMainMenu: true,
                    referenceKey: 'documents',
                    routeOrder: -1,
                    iconCssClass: 'fa fa-file nav-icon'
                }, children: [
                    {
                        path: 'view/:keyValue',
                        component: DwDefaultFormPage,
                        data: {
                            display: 'View',
                            iconCssClass: 'fa fa-edit',
                            excludeFromMainMenu: true,
                            requireAuthentication: true,

                            showInMenu: false,
                            metaDataActionType: 'view',
                            isChild: true,
                            referenceKey: 'mdGridView-view',
                            metaDataItem: AppMetaDataItemNames.DocumentItem,
                            configKeyPart: 'user-documents'
                        }
                    },
                    {
                        path: ':folderId',
                        component: DocumentsPageComponent,
                        canActivate: [AviatorRouteGuardService],
                        data: {
                            routeId: 'documents-new2',
                            display: 'PATH_NAME',
                            showInmenu: true,
                            excludeFromMainMenu: true,
                            referenceKey: 'documentsNew2',
                        }, children: [
                            {
                                path: 'view/:keyValue',
                                component: DwDefaultFormPage,
                                data: {
                                    display: 'View',
                                    iconCssClass: 'fa fa-edit',
                                    excludeFromMainMenu: true,
                                    requireAuthentication: true,
                                    showInMenu: false,
                                    metaDataActionType: 'view',
                                    isChild: true,
                                    referenceKey: 'mdGridView-view',
                                    metaDataItem: AppMetaDataItemNames.DocumentItem,
                                    configKeyPart: 'user-documents'
                                },

                            },
                            {
                                path: ':folderId',
                                component: DocumentsPageComponent,
                                canActivate: [AviatorRouteGuardService],
                                data: {
                                    routeId: 'documents-new2',
                                    display: 'PATH_NAME',
                                    showInmenu: true,
                                    excludeFromMainMenu: true,
                                    referenceKey: 'documentsNew2',
                                }, children: [
                                    {
                                        path: 'view/:keyValue',
                                        component: DwDefaultFormPage,
                                        data: {
                                            display: 'View',
                                            iconCssClass: 'fa fa-edit',
                                            excludeFromMainMenu: true,
                                            requireAuthentication: true,
                                            showInMenu: false,
                                            metaDataActionType: 'view',
                                            isChild: true,
                                            referenceKey: 'mdGridView-view',
                                            metaDataItem: AppMetaDataItemNames.DocumentItem,
                                            configKeyPart: 'user-documents'
                                        }
                                    },
                                    {
                                        path: ':folderId',
                                        component: DocumentsPageComponent,
                                        canActivate: [AviatorRouteGuardService],
                                        data: {
                                            routeId: 'documents-new2',
                                            display: 'PATH_NAME',
                                            showInmenu: true,
                                            excludeFromMainMenu: true,
                                            referenceKey: 'documentsNew2',
                                        }, children: [
                                            {
                                                path: 'view/:keyValue',
                                                component: DwDefaultFormPage,
                                                data: {
                                                    display: 'View',
                                                    iconCssClass: 'fa fa-edit',
                                                    excludeFromMainMenu: true,
                                                    requireAuthentication: true,
                                                    showInMenu: false,
                                                    metaDataActionType: 'view',
                                                    isChild: true,
                                                    referenceKey: 'mdGridView-view',
                                                    metaDataItem: AppMetaDataItemNames.DocumentItem,
                                                    configKeyPart: 'user-documents'

                                                }
                                            },
                                            {
                                                path: ':folderId',
                                                component: DocumentsPageComponent,
                                                canActivate: [AviatorRouteGuardService],
                                                data: {
                                                    routeId: 'documents-new2',
                                                    display: 'PATH_NAME',
                                                    showInmenu: true,
                                                    excludeFromMainMenu: true,
                                                    referenceKey: 'documentsNew2',
                                                }, children: [
                                                    {
                                                        path: 'view/:keyValue',
                                                        component: DwDefaultFormPage,
                                                        data: {
                                                            display: 'View',
                                                            iconCssClass: 'fa fa-edit',
                                                            excludeFromMainMenu: true,
                                                            requireAuthentication: true,
                                                            showInMenu: false,
                                                            metaDataActionType: 'view',
                                                            isChild: true,
                                                            referenceKey: 'mdGridView-view',
                                                            metaDataItem: AppMetaDataItemNames.DocumentItem,
                                                            configKeyPart: 'user-documents'

                                                        }
                                                    },
                                                    {
                                                        path: ':folderId',
                                                        component: DocumentsPageComponent,
                                                        canActivate: [AviatorRouteGuardService],
                                                        data: {
                                                            routeId: 'documents-new2',
                                                            display: 'PATH_NAME',
                                                            showInmenu: true,
                                                            excludeFromMainMenu: true,
                                                            referenceKey: 'documentsNew2',
                                                        }, children: [
                                                            {
                                                                path: 'view/:keyValue',
                                                                component: DwDefaultFormPage,
                                                                data: {
                                                                    display: 'View',
                                                                    iconCssClass: 'fa fa-edit',
                                                                    excludeFromMainMenu: true,
                                                                    requireAuthentication: true,
                                                                    showInMenu: false,
                                                                    metaDataActionType: 'view',
                                                                    isChild: true,
                                                                    referenceKey: 'mdGridView-view',
                                                                    metaDataItem: AppMetaDataItemNames.DocumentItem,
                                                                    configKeyPart: 'user-documents'

                                                                }
                                                            },
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: 'pro-tools',
                component: DocumentsPageComponent,
                canActivate: [AviatorRouteGuardService],
                data: {
                    routeId: 'pro-tools-new',
                    display: 'ProTools',
                    showInMenu: false,
                    excludeFromMainMenu: true,
                    referenceKey: 'pro-tools',
                    routeOrder: -1,
                    iconCssClass: 'fa fa-tools nav-icon'
                }, children: [
                    {
                        path: 'view/:keyValue',
                        component: DwDefaultFormPage,
                        data: {
                            display: 'View',
                            iconCssClass: 'fa fa-edit',
                            excludeFromMainMenu: true,
                            requireAuthentication: true,

                            showInMenu: false,
                            metaDataActionType: 'view',
                            isChild: true,
                            referenceKey: 'mdGridView-view',
                            metaDataItem: AppMetaDataItemNames.DocumentItem,
                            configKeyPart: 'user-documents'
                        }
                    },
                    {
                        path: ':folderId',
                        component: DocumentsPageComponent,
                        canActivate: [AviatorRouteGuardService],
                        data: {
                            routeId: 'pro-tools-new2',
                            display: 'PATH_NAME',
                            showInmenu: true,
                            excludeFromMainMenu: true,
                            referenceKey: 'pro-tools-new2',
                        }, children: [
                            {
                                path: 'view/:keyValue',
                                component: DwDefaultFormPage,
                                data: {
                                    display: 'View',
                                    iconCssClass: 'fa fa-edit',
                                    excludeFromMainMenu: true,
                                    requireAuthentication: true,
                                    showInMenu: false,
                                    metaDataActionType: 'view',
                                    isChild: true,
                                    referenceKey: 'mdGridView-view',
                                    metaDataItem: AppMetaDataItemNames.DocumentItem,
                                    configKeyPart: 'user-documents'
                                },

                            },
                            {
                                path: ':folderId',
                                component: DocumentsPageComponent,
                                canActivate: [AviatorRouteGuardService],
                                data: {
                                    routeId: 'pro-tools-new2',
                                    display: 'PATH_NAME',
                                    showInmenu: true,
                                    excludeFromMainMenu: true,
                                    referenceKey: 'pro-tools-new2',
                                }, children: [
                                    {
                                        path: 'view/:keyValue',
                                        component: DwDefaultFormPage,
                                        data: {
                                            display: 'View',
                                            iconCssClass: 'fa fa-edit',
                                            excludeFromMainMenu: true,
                                            requireAuthentication: true,
                                            showInMenu: false,
                                            metaDataActionType: 'view',
                                            isChild: true,
                                            referenceKey: 'mdGridView-view',
                                            metaDataItem: AppMetaDataItemNames.DocumentItem,
                                            configKeyPart: 'user-documents'
                                        }
                                    },
                                    {
                                        path: ':folderId',
                                        component: DocumentsPageComponent,
                                        canActivate: [AviatorRouteGuardService],
                                        data: {
                                            routeId: 'pro-tools-new2',
                                            display: 'PATH_NAME',
                                            showInmenu: true,
                                            excludeFromMainMenu: true,
                                            referenceKey: 'pro-tools-new2',
                                        }, children: [
                                            {
                                                path: 'view/:keyValue',
                                                component: DwDefaultFormPage,
                                                data: {
                                                    display: 'View',
                                                    iconCssClass: 'fa fa-edit',
                                                    excludeFromMainMenu: true,
                                                    requireAuthentication: true,
                                                    showInMenu: false,
                                                    metaDataActionType: 'view',
                                                    isChild: true,
                                                    referenceKey: 'mdGridView-view',
                                                    metaDataItem: AppMetaDataItemNames.DocumentItem,
                                                    configKeyPart: 'user-documents'

                                                }
                                            },
                                            {
                                                path: ':folderId',
                                                component: DocumentsPageComponent,
                                                canActivate: [AviatorRouteGuardService],
                                                data: {
                                                    routeId: 'pro-tools-new2',
                                                    display: 'PATH_NAME',
                                                    showInmenu: true,
                                                    excludeFromMainMenu: true,
                                                    referenceKey: 'pro-tools-new2',
                                                }, children: [
                                                    {
                                                        path: 'view/:keyValue',
                                                        component: DwDefaultFormPage,
                                                        data: {
                                                            display: 'View',
                                                            iconCssClass: 'fa fa-edit',
                                                            excludeFromMainMenu: true,
                                                            requireAuthentication: true,
                                                            showInMenu: false,
                                                            metaDataActionType: 'view',
                                                            isChild: true,
                                                            referenceKey: 'mdGridView-view',
                                                            metaDataItem: AppMetaDataItemNames.DocumentItem,
                                                            configKeyPart: 'user-documents'

                                                        }
                                                    },
                                                    {
                                                        path: ':folderId',
                                                        component: DocumentsPageComponent,
                                                        canActivate: [AviatorRouteGuardService],
                                                        data: {
                                                            routeId: 'pro-tools-new2',
                                                            display: 'PATH_NAME',
                                                            showInmenu: true,
                                                            excludeFromMainMenu: true,
                                                            referenceKey: 'pro-tools-new2',
                                                        }, children: [
                                                            {
                                                                path: 'view/:keyValue',
                                                                component: DwDefaultFormPage,
                                                                data: {
                                                                    display: 'View',
                                                                    iconCssClass: 'fa fa-edit',
                                                                    excludeFromMainMenu: true,
                                                                    requireAuthentication: true,
                                                                    showInMenu: false,
                                                                    metaDataActionType: 'view',
                                                                    isChild: true,
                                                                    referenceKey: 'mdGridView-view',
                                                                    metaDataItem: AppMetaDataItemNames.DocumentItem,
                                                                    configKeyPart: 'user-documents'

                                                                }
                                                            },
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
        ]
    },
    {
        // Prototype: scenario builder + interactive question types
        path: 'scenario-builder',
        component: ScenarioBuilderPageComponent,
        data: {
            routeId: 'scenario-builder',
            display: 'Scenario Builder',
            parentRouteId: 2070, // Prototypes menu
            routeOrder: 5,
            iconCssClass: 'fa fa-project-diagram',
            requireAuthentication: true,
            showInMenu: true,
            excludeFromMainMenu: true,
            referenceKey: 'scenario-builder',
        }
    },
    {
        // Prototype: Quiz Builder Pro — build a quiz from the Question Bank or AI questions for weak ACS areas
        path: 'quiz-builder-pro',
        component: QuizBuilderProPageComponent,
        data: {
            routeId: 'quiz-builder-pro',
            display: 'Quiz Builder Pro',
            parentRouteId: 2070, // Prototypes menu
            routeOrder: 8,
            iconCssClass: 'fa fa-magic',
            requireAuthentication: true,
            showInMenu: true,
            excludeFromMainMenu: true,
            referenceKey: 'quiz-builder-pro',
        }
    },
    {
        path: 'g1000-trainer',
        component: G1000PrototypePageComponent,
        data: {
            routeId: 'g1000-trainer',
            display: 'Garmin G1000',
            parentRouteId: 2070, // Prototypes menu
            routeOrder: 9,
            iconCssClass: 'fa fa-plane',
            requireAuthentication: true,
            showInMenu: true,
            excludeFromMainMenu: true,
            referenceKey: 'g1000-trainer',
        }
    },
    {
        path: '**',
        // redirectTo: '',
        data: {
            showInMenu: false,
        },
        component: AviatorNotFoundComponent
    }
    // {
    //     path: '---missing-components---',
    //     children: [...DwComponentList, 
    //         { path: 't', component: ServiceDependenciesComponent},
    //         { path: 't1', component: DwGridColumnActionButtonsComponent}
    //        // { path: 't2', component: DwGridQuickSearchActionComponent},

    //     ], 
    // }, 

    // {
    //     path: "**",
    //     redirectTo: '',
    //     data: { 
    //         showInMenu: false
    //     }
    // },

];



// function buildResourceRoutes(pathName: string, displayName: string, iconCssClass: string, referenceKey: string, viewConfigKeyPart: string): Route {
//     const coreRoute = {
//         path: pathName,
//         component: DocumentsPageComponent,
//         canActivate: [AviatorRouteGuardService],
//         data: {
//             routeId: referenceKey,
//             display: displayName,
//             showInmenu: true,
//             excludeFromMainMenu: false,
//             referenceKey: referenceKey,
//             routeOrder: -1,
//             iconCssClass: 'fa fa-file nav-icon'
//         },
//         children: []
//     };

//     coreRoute.children = buildChildRoutes(referenceKey, viewConfigKeyPart);

//     return coreRoute;
// }

// function buildChildRoutes(referenceKey: string, viewConfigKeyPart: string,depth: number = 0, maxDepth: number = 6): any[] {
//     const finalReferenceKey = referenceKey + '_depth_' + depth;
//     const childRoutes = [
//         {
//             path: 'view/:keyValue',
//             component: DwDefaultFormPage,
//             data: {
//                 display: 'View',
//                 iconCssClass: 'fa fa-edit',
//                 excludeFromMainMenu: true,
//                 requireAuthentication: true,

//                 showInMenu: false,
//                 metaDataActionType: 'view',
//                 isChild: true,
//                 referenceKey: 'mdGridView-view',
//                 metaDataItem: AppMetaDataItemNames.DocumentItem,
//                 configKeyPart: viewConfigKeyPart
//             }
//         },
//         {
//             path: ':folderId',
//             component: DocumentsPageComponent,
//             canActivate: [AviatorRouteGuardService],
//             data: {
//                 routeId: finalReferenceKey,
//                 display: 'PATH_NAME',
//                 showInmenu: true,
//                 excludeFromMainMenu: true,
//                 referenceKey: finalReferenceKey,
//             },
//             children: []
//         }
//     ];

//     if (depth < maxDepth) {
//         const grandChildRoutes = buildChildRoutes(referenceKey, viewConfigKeyPart, depth + 1, maxDepth);
//         childRoutes[1].children = grandChildRoutes;
//         return childRoutes;
//     }

//     return childRoutes;
// }

//console.log("Quick Search Action Config", actionRegList);
//console.log("Quick Search Action Config", _dwActionGridQuickSearch);



// DwActionFunc<DwGridActionConfig>({
//     keyName: DwGridActionKeys.gridQuickSearch,
//     display: 'Quick Search',
//     actionType: DwActionType.gridAction,
//     decoratorType: DwDecoratorType.component,
//     configComponent: DwGridQuickSearchConfigComponent,
//     isGlobal: true,
//     allowOnce: true,
//   }, DwGridQuickSearchActionComponent);


// Add Dw Auth Guard to all routes (uses the requireAuthentication and CanAcessPermission data properties)
//DwRouteGuardUtil.secureRoutes(routes, DwAuthGuardService);
DwRouteGuardUtil.secureRoutes(routes, DwAuthGuardService, DwCanDeactivateGuard);

// @NgModule({
//     imports: [  RouterModule.forRoot(routes)],
//     exports: [RouterModule]
// })
// export class AppRoutingModule { }
@NgModule({
    imports: [
        RouterModule.forRoot(routes,
            {
                preloadingStrategy: PreloadAllModules,
                scrollPositionRestoration: 'enabled'
            }),
        DevwareAdminModule.forRoot()
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
